module.exports = __webpack_public_path__ + "static/phone-contact-75aa3b68c5d53d59ecb849f903c7a23d.png";